import { z } from "zod";
import { ProjectSchema } from "./Project";
import { AccountSchema } from "../account";
import { UserSchema } from "../user";

export const ProjectCompleteSchema = z.object({
  projectDetail: z.object({
    project: ProjectSchema,
    account: AccountSchema,
    owner: UserSchema,
  }),
});

export type ProjectComplete = z.infer<typeof ProjectCompleteSchema>;
